import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Container, Grid, Link } from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import Cargo from './Cargo';

// Styles
const useStyles = makeStyles(() => ({
  body: {
    marginTop: -100,
  },
  bodyText: {
    fontSize: '1rem',
    lineHeight: 1.7,
  },
}));

const Body = (props) => {
  const classes = useStyles();
  const { data, pid } = props;
  return (
    <Box>
      <Container maxWidth="lg" className={classes.body}>
        <Grid container>
          <Grid item xs={false} md={1} />
          <Grid item xs={12} md={10}>
            <ReactMarkdown className={classes.bodyText}>{data.body}</ReactMarkdown>
            <Link href="/contact">
              <Button variant="contained" size="large" color="primary">
                Contact us about
                {' '}
                {data.title}
              </Button>
            </Link>
            {pid === 'cargo-handling' ? <Cargo /> : null }
          </Grid>
          <Grid item xs={false} md={1} />
        </Grid>
      </Container>
    </Box>
  );
};

export default Body;
